
import UMUM from "../../library/umum.js";
export default {
    data() {
        return {
            tipe: 0,
            user: null,
            UMUM: UMUM,
            list_permintaan: [],
            mdl_add: false,
            mdl_kirim: false,
            btn_add: false,
            form: {
                permintaan_id: null,
                jam_transfusi: null,
                jenis_reaksi: '',
                jam_terjadi: null,
                jam_dilaporkan: null,
                petugas_pelapor: '',
                tindakan: '',
                pesan_kesan_dokter: ''
            },

            list_data: [],
            list_komponen: [],

            page_first: 1,
            page_last: 0,
            page_limit: 10,
            jml_data: 0,
            total_data: 0,
            cari_value: '',

            mdl_edit: false,
            btn_edit: false,
            form_edit: {
                id: null,
                permintaan_id: null,
                jam_transfusi: null,
                jenis_reaksi: '',
                jam_terjadi: null,
                jam_dilaporkan: null,
                petugas_pelapor: '',
                tindakan: '',
                pesan_kesan_dokter: ''
            },

            mdl_delete: false,
            btn_delete: false,
            delete_id: null,
            hapus_target: null,
            filter: {
                komponen_id: '',
                tipe_transaksi: ''
            },

            modalPemeriksaanOpen: false,
            mdl_pemeriksaan: false,
            pemeriksaanForm: {
                reaksi_id: null,
                dpjp_lab: '',
                asal_darah: '',
                no_kantong: '',
                komponen_darah: '',
                golongan_darah: '',
                uji_silang_serasi: '',
                konfirm_gol_pasien: '',
                konfirm_rhesus_pasien: '',
                konfirm_gol_donor: '',
                konfirm_rhesus_donor: '',
                uji_silang_konfirmasi: '',
                pesan_kesan_dokter: '',
                pemeriksaan_at: ''
            },
            loadingPemeriksaan: false,
            pemeriksaanEditMode: false,
            pemeriksaanEditId: null,


            STATUS_DRAFT: 'draft',
            STATUS_TERKIRIM: 'terkirim',
            loadingKirim: false,
            mdl_view: false,
            loadingView: false,
            viewPemeriksaan: null,

            mdl_pdf_view: false,
            loadingPdfId: null,
            pdfUrl: null,
            pdfName: null,

        }
    },
    methods: {

        cancelKirim() {
            this.kirim_target = null;
            this.mdl_kirim = false;
        },


        openPemeriksaanModal(item) {
            this.pemeriksaanForm = {
                reaksi_id: item.id,
                dpjp_lab: '',
                asal_darah: '',
                no_kantong: '',
                komponen_darah: '',
                golongan_darah: '',
                uji_silang_serasi: '',
                konfirm_gol_pasien: '',
                konfirm_rhesus_pasien: '',
                konfirm_gol_donor: '',
                konfirm_rhesus_donor: '',
                uji_silang_konfirmasi: '',
                pesan_kesan_dokter: item.pesan_kesan_dokter || '',
                pemeriksaan_at: ''
            };
            this.mdl_pemeriksaan = true;
            this.pemeriksaanEditMode = false;
            this.pemeriksaanEditId = null;
            this.mdl_pemeriksaan = true;
        },

        cancelPemeriksaan() {
            this.mdl_pemeriksaan = false;
        },

        async addPemeriksaan() {
            if (!this.pemeriksaanForm.reaksi_id) {
                this.$q.notify({ type: 'negative', message: 'Target reaksi tidak ditemukan.' });
                return;
            }
            if (!this.pemeriksaanForm.no_kantong || !this.pemeriksaanForm.komponen_darah) {
                this.$q.notify({ type: 'negative', message: 'Mohon isi No. Kantong dan Komponen Darah.' });
                return;
            }

            this.loadingPemeriksaan = true;
            const baseURL = this.$store?.state?.url?.REAKSI_TRANSFUSI
                || ((this.$store?.state?.url?.BASE || '') + 'api/v1/reaksi_transfusi/');
            const url = baseURL + 'pemeriksaan/add';

            try {
                const res = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        authorization: 'kikensbatara ' + (localStorage.token || '')
                    },
                    body: JSON.stringify(this.pemeriksaanForm)
                });

                const json = await res.json().catch(() => ({ success: false, message: 'Response parse error' }));

                if (res.ok && (json.success || json.status)) {
                    this.$q.notify({ type: 'positive', message: json.message || 'Pemeriksaan berhasil disimpan.' });
                    this.mdl_pemeriksaan = false;

                    this.getView()
                } else {
                    this.$q.notify({ type: 'negative', message: json.message || `Gagal menyimpan pemeriksaan (${res.status})` });
                }
            } catch (err) {
                console.error('addPemeriksaan error', err);
                this.$q.notify({ type: 'negative', message: 'Terjadi kesalahan saat menyimpan pemeriksaan.' });
            } finally {
                this.loadingPemeriksaan = false;
            }
        },
        openPemeriksaan(data) {
            const isAdminRuangan = (Number(this.tipe) === 3);

            if (isAdminRuangan && data.status === this.STATUS_DRAFT) {
                this.openKirimConfirmation(data);
                return;
            }
            const isUPD = Number(this.tipe) === 1 || Number(this.tipe) === 2;
            if (isUPD && data.status === this.STATUS_TERKIRIM) {
                this.pemeriksaanForm = { reaksi_id: data.id };
                this.modalPemeriksaanOpen = true;
                return;
            }

            // default: buka modal pemeriksaan
            this.pemeriksaanForm = { reaksi_id: data.id };
            this.modalPemeriksaanOpen = true;
        },





        openKirimConfirmation(item) {
            this.kirim_target = item;
            this.mdl_kirim = true;
        },
        async confirmKirim() {
            const id = this.kirim_target.id;
            const base = this.$store.state.url.REAKSI_TRANSFUSI;
            await fetch(base + id + "/send", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + (localStorage.token || '')
                },
                body: JSON.stringify({ status: 'terkirim' })
            });
            this.kirim_target.status = "terkirim";
            this.mdl_kirim = false;
            this.getView();
        },

        handleOptionClick(scope) {
            this.form.permintaan_id = scope.opt.id;
            this.$refs.select.hidePopup();
        },

        async getData() {
            try {
                const baseURL = this.$store.state.url.REAKSI_TRANSFUSI
                    || (this.$store.state.url.BASE || '') + "api/v1/reaksi_transfusi/";

                // jika form.ruangan_id ada, tambahkan param
                const url = this.form.ruangan_id ? `${baseURL}?ruangan_id=${this.form.ruangan_id}` : baseURL;

                console.log("fetch url:", url);

                const res = await fetch(url, {
                    method: "GET",
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    }
                });

                const json = await res.json();
                console.log("getData json:", json);

                if (json.status) {
                    this.list_permintaan = json.permintaan || [];
                    this.table_data = json.reaksi || [];
                    if (this.list_permintaan.length && !this.form.permintaan_id) {
                        this.form.permintaan_id = this.list_permintaan[0].id;
                    }
                } else {
                    this.list_permintaan = [];
                    this.table_data = [];
                }
            } catch (err) {
                console.error("getData error:", err);
                this.list_permintaan = [];
                this.table_data = [];
            }
        },

        addData() {
            console.log('DEBUG addData payload:', this.form);
            this.btn_add = true;

            fetch(this.$store.state.url.REAKSI_TRANSFUSI + "addData", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify(this.form)
            })
                .then(res => res.json())
                .then(res_data => {
                    if (res_data.success || res_data.status) {
                        this.$q.notify({
                            type: "positive",
                            message: res_data.message || "Laporan Reaksi Transfusi berhasil ditambahkan"
                        });

                        this.mdl_add = false;
                        this.resetForm();
                        this.getView();
                    } else {
                        this.$q.notify({
                            type: "negative",
                            message: res_data.message || "Gagal menambah laporan reaksi transfusi"
                        });
                    }
                })
                .catch(err => {
                    console.error("Error addData:", err);
                    this.$q.notify({
                        type: "negative",
                        message: "Terjadi kesalahan saat menyimpan data"
                    });
                })
                .finally(() => {
                    this.btn_add = false;
                });
        },

        resetForm() {
            this.form = {
                permintaan_id: null,

                jam_transfusi: "",
                jenis_reaksi: "",
                jam_terjadi: "",
                jam_dilaporkan: "",
                petugas_pelapor: "",
                tindakan: "",
                pesan_kesan_dokter: "",

                ruangan_id: this.form?.ruangan_id || null,
                rumah_sakit_id: this.form?.rumah_sakit_id || null
            };
        },

        getView() {
            const query = new URLSearchParams({
                page: this.page_first,
                limit: this.page_limit,
                cari_value: this.cari_value || ''
            }).toString();

            fetch(this.$store.state.url.REAKSI_TRANSFUSI + "view?" + query, {
                method: "GET",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                }
            })
                .then(res => res.json())
                .then(res_data => {
                    console.log('getView response:', res_data);

                    if (res_data.success) {
                        this.list_data = res_data.data || [];
                        this.total_data = res_data.total_data || 0;
                        this.page_last = res_data.total_pages || 1;
                        this.jml_data = this.list_data.length;

                        if (this.page_first > this.page_last) {
                            this.page_first = this.page_last || 1;
                        }
                    } else {
                        this.$q.notify({
                            type: 'negative',
                            message: res_data.message || 'Gagal memuat data reaksi transfusi'
                        });
                    }
                })
                .catch(err => {
                    console.error('Error fetching reaksi transfusi:', err);
                    this.$q.notify({
                        type: 'negative',
                        message: 'Terjadi kesalahan saat memuat data reaksi transfusi'
                    });
                });
        },

        async openLihat(item) {
            // item adalah row dari list_data, berisi id (reaksi id)
            if (!item || !item.id) {
                this.$q.notify({ type: 'negative', message: 'Data tidak valid' });
                return;
            }

            this.loadingView = true;
            this.viewPemeriksaan = null;
            this.mdl_view = true;

            const baseURL = this.$store?.state?.url?.REAKSI_TRANSFUSI
                || ((this.$store?.state?.url?.BASE || '') + 'api/v1/reaksi_transfusi/');
            const url = baseURL + 'pemeriksaan/view?reaksi_id=' + encodeURIComponent(item.id);

            try {
                const res = await fetch(url, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        authorization: 'kikensbatara ' + (localStorage.token || '')
                    }
                });
                const json = await res.json().catch(() => ({ success: false, message: 'Response parse error' }));
                if (res.ok && (json.success || json.status)) {
                    this.viewPemeriksaan = json.data;
                } else {
                    this.viewPemeriksaan = null;
                    this.$q.notify({ type: 'negative', message: json.message || 'Gagal memuat data pemeriksaan' });
                }
            } catch (err) {
                console.error('openLihat error', err);
                this.$q.notify({ type: 'negative', message: 'Terjadi kesalahan saat memuat data pemeriksaan' });
                this.viewPemeriksaan = null;
            } finally {
                this.loadingView = false;
            }
        },

        openEditPemeriksaan(dataPemeriksaan) {
            // Tutup detail view
            this.mdl_view = false;

            // Debug: lihat payload
            console.log('openEditPemeriksaan payload:', dataPemeriksaan, 'list_komponen:', this.list_komponen);

            // Pastikan kita punya data pemeriksaan dan id pemeriksaan
            // Kadang field id bisa bernama 'id' atau 'pemeriksaan_id' tergantung response
            const pemeriksaanId = dataPemeriksaan?.id || dataPemeriksaan?.pemeriksaan_id || null;
            if (!pemeriksaanId) {
                this.$q.notify({ type: 'negative', message: 'ID pemeriksaan tidak ditemukan — tidak bisa edit.' });
                return;
            }

            // Cari komponen di list_komponen. dataPemeriksaan.komponen_darah mungkin mengandung id atau nama.
            let komponenValue = null;
            if (this.list_komponen && this.list_komponen.length) {
                // jika dataPemeriksaan.komponen_darah adalah angka/id:
                const asNumber = Number(dataPemeriksaan.komponen_darah);
                if (!isNaN(asNumber) && asNumber > 0) {
                    const foundById = this.list_komponen.find(k => Number(k.id) === asNumber);
                    if (foundById) komponenValue = foundById.id;
                }
                // jika belum ditemukan, cari berdasarkan nama_komponen
                if (!komponenValue) {
                    const foundByName = this.list_komponen.find(k => String(k.nama_komponen).trim() === String(dataPemeriksaan.komponen_darah).trim());
                    if (foundByName) komponenValue = foundByName.id;
                }
            }

            // Inisialisasi form dengan data pemeriksaan yang dikirim
            this.pemeriksaanForm = {
                reaksi_id: dataPemeriksaan.reaksi_id || dataPemeriksaan.reaksi_id || null,
                dpjp_lab: dataPemeriksaan.dpjp_lab || '',
                asal_darah: dataPemeriksaan.asal_darah || '',
                no_kantong: dataPemeriksaan.no_kantong || '',
                // set komponen_darah ke ID dari list_komponen — agar q-select bisa menampilkan labelnya
                komponen_darah: komponenValue !== null ? komponenValue : (dataPemeriksaan.komponen_darah || ''),
                golongan_darah: dataPemeriksaan.golongan_darah || '',
                uji_silang_serasi: dataPemeriksaan.uji_silang_serasi || '',
                konfirm_gol_pasien: dataPemeriksaan.konfirm_gol_pasien || '',
                konfirm_rhesus_pasien: dataPemeriksaan.konfirm_rhesus_pasien || '',
                konfirm_gol_donor: dataPemeriksaan.konfirm_gol_donor || '',
                konfirm_rhesus_donor: dataPemeriksaan.konfirm_rhesus_donor || '',
                uji_silang_konfirmasi: dataPemeriksaan.uji_silang_konfirmasi || '',
                pesan_kesan_dokter: dataPemeriksaan.pesan_kesan_dokter || '',
                // format untuk datetime-local
                pemeriksaan_at: this.formatDatetimeLocal(dataPemeriksaan.pemeriksaan_at || dataPemeriksaan.pemeriksaan_created || '')
            };

            // set mode edit
            this.pemeriksaanEditMode = true;
            this.pemeriksaanEditId = pemeriksaanId;

            // buka modal pemeriksaan (reuse modal add)
            this.mdl_pemeriksaan = true;
        },

        async submitPemeriksaan() {
            console.log('submitPemeriksaan: editMode=', this.pemeriksaanEditMode, 'editId=', this.pemeriksaanEditId);
            if (this.pemeriksaanEditMode) {
                await this.updatePemeriksaan();
            } else {
                await this.addPemeriksaan();
            }
        },


        // update pemeriksaan yang sudah ada
        async updatePemeriksaan() {
            if (!this.pemeriksaanEditId) {
                this.$q.notify({ type: 'negative', message: 'ID pemeriksaan tidak ditemukan.' });
                return;
            }

            if (!this.pemeriksaanForm.no_kantong || !this.pemeriksaanForm.komponen_darah) {
                this.$q.notify({ type: 'negative', message: 'Mohon isi No. Kantong dan Komponen Darah.' });
                return;
            }

            this.loadingPemeriksaan = true;
            try {
                const baseURL = this.$store?.state?.url?.REAKSI_TRANSFUSI
                    || ((this.$store?.state?.url?.BASE || '') + 'api/v1/reaksi_transfusi/');
                const url = baseURL + 'pemeriksaan/edit';

                // Include pemeriksaan id
                const payload = Object.assign({}, this.pemeriksaanForm, { id: this.pemeriksaanEditId });

                console.log('updatePemeriksaan payload:', payload);

                const res = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        authorization: 'kikensbatara ' + (localStorage.token || '')
                    },
                    body: JSON.stringify(payload)
                });

                const json = await res.json().catch(() => ({ success: false, message: 'Response parse error' }));

                if (res.ok && (json.success || json.status)) {
                    this.$q.notify({ type: 'positive', message: json.message || 'Pemeriksaan berhasil diperbarui.' });
                    this.mdl_pemeriksaan = false;

                    // reset edit mode
                    this.pemeriksaanEditMode = false;
                    this.pemeriksaanEditId = null;

                    // refresh daftar & view
                    this.getView();

                    // Jika server mengembalikan data pemeriksaan baru, perbarui viewPemeriksaan
                    if (json.data) {
                        this.viewPemeriksaan = json.data;
                    }
                } else {
                    console.error('updatePemeriksaan failed:', res.status, json);
                    this.$q.notify({ type: 'negative', message: json.message || `Gagal memperbarui pemeriksaan (${res.status})` });
                }
            } catch (err) {
                console.error('updatePemeriksaan error', err);
                this.$q.notify({ type: 'negative', message: 'Terjadi kesalahan saat memperbarui pemeriksaan.' });
            } finally {
                this.loadingPemeriksaan = false;
            }
        },



        getKomponen() {
            fetch(this.$store.state.url.KOMPONEN + "view", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({})
            })
                .then(res => res.json())
                .then(res_data => {
                    this.list_komponen = res_data.data || []
                })
                .catch(err => console.error("Error getKomponen:", err))
        },

        openLihatDokumen(item) {
            this.loadingPdfId = item.id;

            if (!item || !item.id) {
                this.$q.notify({ type: 'negative', message: 'Data tidak valid' });
                return;
            }

            const token = localStorage.token || '';
            if (!token) {
                this.$q.notify({ type: 'negative', message: 'Token autentikasi tidak ditemukan. Silakan login ulang.' });
                return;
            }

            const base = this.$store?.state?.url?.REAKSI_TRANSFUSI
                || ((this.$store?.state?.url?.BASE || '') + 'api/v1/reaksi_transfusi/');
            const url = base + 'pemeriksaan/pdf?reaksi_id=' + encodeURIComponent(item.id); // Tanpa token di URL

            // Fetch PDF dengan header Authorization
            fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': 'kikensbatara ' + token,
                    'Content-Type': 'application/pdf'
                }
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Gagal memuat PDF: ' + response.status);
                    }
                    return response.blob();
                })
                .then(blob => {
                    // Buat URL blob dan buka di tab baru (tanpa token di URL)
                    const blobUrl = URL.createObjectURL(blob);
                    window.open(blobUrl, '_blank');
                })
                .catch(error => {
                    console.error('Error opening PDF:', error);
                    this.$q.notify({ type: 'negative', message: 'Gagal membuka dokumen. Periksa koneksi atau coba lagi.' });
                })
                .finally(() => {
                    this.loadingPdfId = null;
                });
        },

        async loadPdfInModal(pdfUrl) {
            this.loadingPdf = true;
            this.pdfUrl = null;
            this.pdfName = 'reaksi_transfusi.pdf';
            this.mdl_pdf_view = true;
            try {
                // Fetch PDF sebagai blob dengan header Authorization
                const response = await fetch(pdfUrl, {
                    method: 'GET',
                    headers: {
                        'Authorization': 'kikensbatara ' + (localStorage.token || ''),
                        'Content-Type': 'application/pdf' // Opsional, untuk memastikan
                    }
                });
                if (!response.ok) {
                    throw new Error(`Gagal memuat PDF: ${response.status} - ${response.statusText}`);
                }
                const blob = await response.blob();
                this.pdfUrl = URL.createObjectURL(blob);
            } catch (error) {
                console.error('Error loading PDF in modal:', error);
                this.$q.notify({ type: 'negative', message: 'Gagal memuat PDF. Periksa koneksi atau data.' });
                this.closePdfModal(); // Tutup modal jika error
            } finally {
                this.loadingPdf = false;
            }
        },

        downloadPdf() {
            if (!this.pdfUrl) {
                this.$q.notify({ type: 'negative', message: 'Tidak ada PDF untuk didownload.' });
                return;
            }
            const a = document.createElement('a');
            a.href = this.pdfUrl;
            a.download = this.pdfName || 'reaksi_transfusi.pdf';
            document.body.appendChild(a);
            a.click();
            a.remove();
        },
        closePdfModal() {
            if (this.pdfUrl && this.pdfUrl.startsWith('blob:')) {
                URL.revokeObjectURL(this.pdfUrl);
            }
            this.pdfUrl = null;
            this.pdfName = null;
            this.mdl_pdf_view = false;
        },

        formatDatetimeLocal(dateStr) {
            if (!dateStr) return '';

            // 1. Ubah string dari database menjadi Objek Date
            // Browser otomatis akan mengonversi UTC ke Waktu Lokal (WIB/WITA/WIT) di sini
            const d = new Date(dateStr);

            // Validasi jika tanggal error/invalid
            if (isNaN(d.getTime())) return '';

            // 2. Ambil komponen waktu berdasarkan LOKAL komputer user
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0'); // Ingat: getMonth() mulai dari 0
            const day = String(d.getDate()).padStart(2, '0');
            const hours = String(d.getHours()).padStart(2, '0');     // Ini akan mengambil jam lokal, bukan UTC
            const minutes = String(d.getMinutes()).padStart(2, '0');

            // 3. Gabungkan menjadi format string yang diterima input datetime-local (YYYY-MM-DDTHH:mm)
            return `${year}-${month}-${day}T${hours}:${minutes}`;
        },

        openEdit(data) {
            // Copy data dari baris tabel ke form_edit
            this.form_edit = {
                id: data.id,
                permintaan_id: data.permintaan_id,
                // Format tanggal agar terbaca di input type="datetime-local"
                jam_transfusi: this.formatDatetimeLocal(data.jam_transfusi),
                jenis_reaksi: data.jenis_reaksi,
                jam_terjadi: this.formatDatetimeLocal(data.jam_terjadi),
                jam_dilaporkan: this.formatDatetimeLocal(data.jam_dilaporkan),
                petugas_pelapor: data.petugas_pelapor,
                tindakan: data.tindakan,
                pesan_kesan_dokter: data.pesan_kesan_dokter || ''
            };

            this.mdl_edit = true;
        },

        updateData() {
            this.btn_edit = true;
            const baseURL = this.$store.state.url.REAKSI_TRANSFUSI
                || (this.$store.state.url.BASE || '') + "api/v1/reaksi_transfusi/";

            fetch(baseURL + "editData", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify(this.form_edit)
            })
                .then(res => res.json())
                .then(res_data => {
                    if (res_data.success || res_data.status) {
                        this.$q.notify({
                            type: "positive",
                            message: res_data.message || "Data berhasil diperbarui"
                        });
                        this.mdl_edit = false;
                        this.getView(); // Refresh tabel
                    } else {
                        this.$q.notify({
                            type: "negative",
                            message: res_data.message || "Gagal memperbarui data"
                        });
                    }
                })
                .catch(err => {
                    console.error("Error updateData:", err);
                    this.$q.notify({
                        type: "negative",
                        message: "Terjadi kesalahan saat menyimpan perubahan"
                    });
                })
                .finally(() => {
                    this.btn_edit = false;
                });
        },

        openDelete(data) {
            // Simpan ID yang akan dihapus
            this.delete_id = data.id;
            // Buka modal konfirmasi
            this.mdl_delete = true;
        },

        deleteData() {
            this.btn_delete = true;

            const baseURL = this.$store.state.url.REAKSI_TRANSFUSI
                || (this.$store.state.url.BASE || '') + "api/v1/reaksi_transfusi/";

            fetch(baseURL + "delete", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({ id: this.delete_id }) // Kirim hanya ID
            })
                .then(res => res.json())
                .then(res_data => {
                    if (res_data.success || res_data.status) {
                        this.$q.notify({
                            type: "positive",
                            message: res_data.message || "Data berhasil dihapus"
                        });
                        this.mdl_delete = false;
                        this.getView(); // Refresh tabel
                    } else {
                        this.$q.notify({
                            type: "negative",
                            message: res_data.message || "Gagal menghapus data"
                        });
                    }
                })
                .catch(err => {
                    console.error("Error deleteData:", err);
                    this.$q.notify({
                        type: "negative",
                        message: "Terjadi kesalahan saat menghapus data"
                    });
                })
                .finally(() => {
                    this.btn_delete = false;
                    this.delete_id = null; // Reset ID
                });
        },



        indexing(idx) {
            return ((this.page_first - 1) * this.page_limit) + idx
        },

        formatTanggal(dt) {
            if (!dt) return '-'
            const d = new Date(dt)
            if (isNaN(d)) return dt
            return d.toLocaleString('id-ID', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            })
        },

        cari_data() {
            this.page_first = 1
            this.getView()
        },

        // 🔹 Terapkan filter
        applyFilter() {
            this.page_first = 1;
            this.getView();
        },
    },

    mounted() {
        try {
            const get_profile = JSON.parse(localStorage.profile || '{}')
            if (get_profile && get_profile.profile) {
                this.tipe = Number(get_profile.profile.stokdarah_konut)
                this.user = get_profile
                // jika admin ruangan otomatis isi rumah_sakit_id / ruangan_id jika tersedia di profile
                if (get_profile.profile.ruangan_id) {
                    this.form.ruangan_id = Number(get_profile.profile.ruangan_id)
                }
                if (get_profile.profile.rumah_sakit_id) {
                    this.form.rumah_sakit_id = Number(get_profile.profile.rumah_sakit_id)
                }
            }
        } catch (e) {
            console.warn('Gagal parse localStorage.profile', e)
        }
        this.getData();
        this.getKomponen();
        this.getView();
    }
}
